<template>
  <!-- #region template -->
  <div class="home vh-100 vw-100">
    <template v-if="busy">
      <!-- // TODO Task: Loading Animation - Comment: Create some sort of visual loading animation -->
    </template>
    <template v-else>
      <div class="home__nav h-100 position-fixed d-flex justify-content-center p-5" v-bind:style="navStyle">
        <div class="d-flex flex-column justify-content-between">
          <cNav />
          <cLogo />
        </div>
      </div>
      <div class="home__main h-100 overflow-auto custom-scrollbar" v-bind:style="mainStyle">
        <div class="home__header position-fixed px-2 py-3" v-bind:class="headerClass">
          <cHeader />
        </div>
        <div class="px-2 py-4" style="margin-top: 4rem">
          <div class="position-fixed" style="z-index: 9999; width: 500px; top: 100px; right: 50px">
            <b-alert v-for="(alert, index) in alerts" :key="index" class="shadow" :show="alert.show" :dismissible="alert.dismissible" :variant="alert.variant" @dismissed="alert.show = 0">{{ alert.message }}</b-alert>
          </div>
          <template v-if="view == 'dashboard'">
            <template v-if="$route.query.dashboard == 'Analytics'">
              <dAnalytics />
            </template>
            <template v-else>
              <cDashboard :dashboard="dashboard" :key="$route.query.dashboard" />
            </template>
          </template>
          <template v-if="view == 'extensions'">
            <template v-if="$route.query.extensions == 'medialibrary'">
              <MediaLibrary />
            </template>
            <template v-if="$route.query.extensions == 'settings'">
              <Settings />
            </template>
          </template>
        </div>
      </div>
    </template>
  </div>
  <!-- #endregion -->
</template>

<script>
// #region script
// #region import
import cNav from '@/components/cNav.vue'
import cLogo from '@/components/cLogo.vue'
import cHeader from '@/components/cHeader.vue'
import cDashboard from '@/components/cDashboard.vue'
import MediaLibrary from '@/views/extensions/MediaLibrary.vue'
import Settings from '@/views/extensions/Settings.vue'
import dAnalytics from '@/components/dashboards/dAnalytics.vue'
import { NavState } from '@/utils'
import { mapState, mapActions, mapGetters } from 'vuex'
// #endregion

// #region export
export default {
  name: 'Home',
  components: {
    cNav,
    cLogo,
    cHeader,
    cDashboard,
    MediaLibrary,
    Settings,
    dAnalytics,
  },
  data() {
    return {
      dashboard: {},
      view: '',
      busy: false,
    }
  },
  computed: {
    ...mapState({
      //dashboards: (state) => state.app.apps[0].dashboards,
      alerts: (state) => state.report.alerts,
      navState: 'navState',
    }),
    ...mapGetters('app', ['dashboards']),
    headerClass() {
      return this.navState == NavState.Open ? 'a' : 'b'
    },
    navStyle() {
      return this.navState == NavState.Open ? { transform: 'translateX(0px)' } : { transform: 'translateX(-100%)' }
    },
    mainStyle() {
      return this.navState == NavState.Open ? { 'margin-left': '260px' } : {}
    },
  },
  watch: {
    $route() {
      this.setup()
    },
  },
  mounted() {
    this.setup()
  },
  methods: {
    ...mapActions(['report/alert']),
    setup() {
      this.busy = true
      if (this.$route.query.extension) {
        this.view = 'extensions'
      } else {
        if (this.$route.query.dashboard) {
          for (let i = 0; i < this.dashboards.length; i++) {
            if (this.dashboards[i].name == this.$route.query.dashboard) {
              this.dashboard = this.dashboards[i]
              break
            }
          }
        } else {
          this.$router.push(`?dashboard=${this.dashboards[0].name}`)
        }
        this.view = 'dashboard'
      }
      this.busy = false
    },
  },
}
// #endregion
// #endregion
</script>

<style lang="scss">
// #region style
$nav-width: 260px;
.home {
  background-color: #f9f9f9;
  // background: linear-gradient(45deg, #313c3f, #232e31);
  &__nav {
    background-color: #f0f0f0;
    // background-color: #253235;
    width: 260px;
    transition: transform 250ms ease-in-out;
  }
  &__main {
    transition: margin 250ms ease-in-out;
  }
  &__header {
    top: 0;
    z-index: 1;

    background-color: #ffffff;
    border-bottom: solid 1px #e4e4e4;
  }
}
.a {
  width: calc(100% - 260px);
}
.b {
  width: 100%;
}
// #endregion
</style>
